export type PackageType =
  | "LANDING_PAGE"
  | "BRAND_PACKAGE"
  | "BASIC_MVP"
  | "ADVANCED_MVP";

export function formatPrice(cents: number): string {
  return `$${(cents / 100).toFixed(0)}`;
}
